import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from '@bootstraplabs/bsw-common-react';
import { thousandSeparator } from '../../../utils/utils';
export function OptionGrantListItem(props) {
    return (_jsx(ListItem, { primary: props.holder, secondary: props.state, label: thousandSeparator(props.quantity), chevron: true, onClick: props.onClick }, void 0));
}
//# sourceMappingURL=option-grant-list-item.js.map